module.exports = __webpack_public_path__ + "img/sample.c50b20c7.jpg";